import { usePathname } from 'next/navigation';

import {
  ADDITIONAL_RESPONSIVE_LAYOUT_PATHNAMES,
  LOCAL_MARKET_ROUTES,
  ROUTE_TYPES,
} from '@/constants';
import { type LayoutType, useGlobalStore } from '@/stores/GlobalStore';

/**
 * layoutType을 반환하는 순수 훅
 *
 * useOverrideLayoutTypeEffect에서 overrideLayoutType이 설정되면 그 값을, 아니면 기본 값 반환
 */
export const useLayoutType = () => {
  const pathname = usePathname();
  const currentRouteType = useGlobalStore((state) => state.currentRouteType);
  const overrideLayoutType = useGlobalStore(
    (state) => state.overrideLayoutType,
  );

  const isDonationPrefix = pathname?.startsWith('/donation');
  const isLocalMarketPrefix = pathname?.startsWith(
    LOCAL_MARKET_ROUTES.HOME.pathname,
  );
  const isMyPage = pathname === '/my';
  const isLocalMarket =
    pathname?.startsWith('/my/orders') ||
    pathname?.startsWith('/my/reviews') ||
    pathname?.startsWith('/my/delivery-address') ||
    pathname?.startsWith('/my/product-coupons');
  const isAdditionalResponsiveLayoutPathname =
    ADDITIONAL_RESPONSIVE_LAYOUT_PATHNAMES.includes(pathname ?? '');

  /** 이에 따라 donation-layout.scss, wello-layout.scss 스타일이 적용됨 */
  const defaultLayoutType: LayoutType = (() => {
    if (isDonationPrefix) return 'donation';
    if (isLocalMarketPrefix) return 'local-market';
    if (isLocalMarket) return 'local-market';
    if (isMyPage) return 'donation';

    if (
      isAdditionalResponsiveLayoutPathname &&
      currentRouteType === ROUTE_TYPES.DONATION
    ) {
      return 'donation';
    }

    return 'wello';
  })();

  //* overrideLayoutType이 설정되면 그 값을, 아니면 기본 계산값 반환
  const layoutType = overrideLayoutType ?? defaultLayoutType;

  return {
    layoutType,
    pathname,
  };
};
